<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import UserDetailContactsTile from '@/components/user/tiles/UserDetailContactsTile.vue';
import UserDetailSettingsTile from '@/components/user/tiles/UserDetailSettingsTile.vue';
import UserDetailMainInfoTile from '@/components/user/tiles/UserDetailMainInfoTile.vue';
import UserDetailFinancesTile from '@/components/user/tiles/UserDetailFinancesTile.vue';
import UserDetailProjectsTile from '@/components/user/tiles/UserDetailProjectsTile.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'UserDetailCommonTab',
  components: {
    DefaultLayout,
    CommonSection,
    FormBlock,
    UserDetailContactsTile,
    UserDetailSettingsTile,
    UserDetailMainInfoTile,
    UserDetailFinancesTile,
    UserDetailProjectsTile,
    BaseButton,
  },
  props: {
    item: Object,
    isEditMode: Boolean,
    isAdmin: Boolean,
  },
};
</script>

<template lang="pug">
  .b-user-detail-common-tab(:class="{ 'edit-mode': isEditMode }")
    UserDetailContactsTile._contacts(:value="item" :isEditMode="isEditMode" @change="$emit('change', $event)" :class="{ 'edit-mode-contacts': isEditMode }")
    UserDetailSettingsTile._settings(:value="item" :isEditMode="isEditMode" @change="$emit('change', $event)" :class="{ 'edit-mode-settings': isEditMode }")
    UserDetailMainInfoTile._main-info(:value="item" :isEditMode="isEditMode" @change="$emit('change', $event)" @onAvatarChanged="$emit('onAvatarChanged', $event)" :class="{ 'edit-mode-main-info': isEditMode }")
    UserDetailFinancesTile._finances(
      :value="item"
      :isEditMode="isEditMode"
      :isAdmin="isAdmin"
      @onChange="$emit('change', $event)"
      @goToTariffs="$emit('goToTariffs', $event)"
      @topUpBalance="$emit('showPopup', $event)"
      :class="{ 'edit-mode-finances': isEditMode, 'hide-finances': !isAdmin && isEditMode }"
      )
    ._projects
      UserDetailProjectsTile(v-if="!isEditMode" :user="item")
      ._button(v-if="!isEditMode")
        BaseButton(v-if="isAdmin && !item.accountBlocked" @click="$emit('confirm', { accountBlocked: true, accountBlockedAt: new Date() })" blue round lg) Заблокировать
        BaseButton(v-if="isAdmin && item.accountBlocked" @click="$emit('confirm', { accountBlocked: false })" blue round lg) Разблокировать
        BaseButton(@click="$emit('deleteAccount', item.id)" grey round lg)
          ._button-label
            Icon(name="trash")
            ._button-text Удалить аккаунт
        BaseButton(v-if="isAdmin && !item.accountConfirmed" @click="$emit('confirm', { accountConfirmed: true, activatedAt: new Date() })" blue round lg) Активировать
</template>

<style scoped lang="scss">
.user-detail-common-tab {
  display: grid;
  grid-template-columns: 1fr 1fr 312px;
  grid-auto-rows: min-content min-content min-content min-content;
  gap: 38px;

  &__contacts, &__settings {
    grid-row: 2 / 3 span;
  }

  &__main-info {
    grid-row: 1 / 2 span;
    grid-column: 3;
  }

  &__finances {
    grid-column: 1 / 2 span;
    grid-row: 1;
  }

  &__projects {
    display: flex;
    flex-direction: column;
    gap: 40px;
    grid-column: 3;
    grid-row: 3 / 4 span;
  }

  &__button {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
  }

  &__button-label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__button-text {
    font-family: Geometria, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
  }

  .edit-mode {
    grid-auto-rows: min-content min-content min-content;
  }

  .edit-mode-main-info {
    grid-row: 1;
  }

  .edit-mode-finances {
    grid-row: 2;
  }

  .edit-mode-projects {
    grid-row: 2;
    justify-content: space-between;
  }

  .edit-mode-button {
    grid-row: 3;
    justify-content: flex-start;
  }

  .edit-mode-contacts {
    grid-row: 1;
  }

  .edit-mode-settings {
    grid-row: 1;
  }

  .hide-finances {
    display: none;
    grid-row: 2;
  }
}
</style>
